<template>
	<vxe-modal :loading="loading" v-model="modalShow" :width="width" :height="height"
		:title="title+'【'+(extra.controllname?extra.controllname:'表单预览')+'】'" destroy-on-close @show="show"
		@hide="hide" transfer>
		<template #default>
			<div ref="preview_form" :style="{opacity:previewShow?1:0}"></div>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		name: 'formPreview',
		extends: formBase,
		props: {

		},
		data() {
			return {
				previewShow:false
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.width = this.extra.rule.width
				this.height = this.extra.rule.height
				this.title = this.extra.title
				this.loading = false
				this.modalShow = true
			},
			show() {

				// this.fApi.nextTick(() => {
				// 	rule.forEach((item) => {
				// 		if (item.type == '$quote' && item.props.button) {
				// 			this.fApi.getRule(item.field).on = {
				// 				submit: this.boxSubmit
				// 			}
				// 		}
				// 		if (item.type == '$popover') {
				// 			let mountcomponent = this.fApi.el(item.props.mountcomponent)
				// 			this.fApi.el(item.field).setComponent(mountcomponent)
				// 		}
				// 	})
				// 	if (this.regestEvent) {
				// 		this.regestEvent(rule, this.fApi)
				// 	}

				// 	//console.log(rule)
				// 	if (this.id != 0) {
				// 		this.get()
				// 	} else {
				// 		this.loading = false
				// 	}
				// })

	
		
				let rule = JSON.parse(JSON.stringify(this.extra.rule.rule))
				let option = this.extra.rule.option
				option.el = this.$refs.preview_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.autoRegest(rule)
					let fields = this.fApi.fields()
					if (this.extra.controll) {
						fields.forEach((item) => {
							if (item.indexOf('$son') != -1) {
								let rule = this.fApi.getRule(item)
								rule.props.buttons.forEach((_item) => {
									if (this.extra.controll[item + '_button'].indexOf(_item
										.code) ==
										-1) {
										_item.disabled = true
									} else {
										_item.disabled = false
									}
								})
								rule.props.fields.forEach((_item, index) => {
									rule.props.fields[index] = this.assiginObj(rule.props.fields[index],this.extra.controll[item + '_' + _item.field])
								})
								this.fApi.updateRule(item, rule)
								this.fApi.exec(item, 'initTable')
							} else {
								this.fApi.mergeRule(item, this.extra.controll[item])
							}
						})

					}
					this.checkDivider(rule)
					this.previewShow = true
				})
			},
			regestEvent(){
				
			},
			assiginObj(target = {}, sources = {}) {
				let obj = target
				if (typeof target != 'object' || typeof sources != 'object') {
					return sources
				}
				for (let key in sources) {
					if (Object.hasOwn(target,key)) {
						obj[key] = this.assiginObj(target[key], sources[key])
					} else {
						obj[key] = sources[key]
					}
				}
				return obj
			}
		},
		components: {

		}
	}
</script>
